module.exports = __webpack_public_path__ + "img/elec_num.999362e6.png";